import { render, staticRenderFns } from "./FormCallMe.vue?vue&type=template&id=2aa0686b&"
import script from "./FormCallMe.vue?vue&type=script&lang=ts&"
export * from "./FormCallMe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports